// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import * as ReactDOM from "react-dom";
import { DragOverlay } from "@dnd-kit/core";
import DashboardWidget from "./DashboardWidget";
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardGridOverlay = props => {
  const {
    ...rest
  } = props;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(DragOverlay, {
    children: /*#__PURE__*/_jsx(DashboardWidget, {
      ...rest,
      overlay: true
    })
  }), document.body);
};
export default DashboardGridOverlay;